import React from 'react'
import { Tag } from 'antd'

// Format admission date
export const formatDate = (date) => {
  return new Date(date).toLocaleString()
}

// Get status tag for admission status
export const getStatusTag = (status) => {
  return (
    <Tag color={status === 'Active' ? 'green' : status === 'Discharged' ? 'volcano' : 'blue'}>
      {status.toUpperCase()}
    </Tag>
  )
}
